import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AdminRouter = () => {

  const location = useLocation();
  const token = localStorage.getItem("admin_token");
  const role = localStorage.getItem("admin_role");

  if (!token) {
    return (
      <Navigate
        to="/admin-login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  if (role && role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AdminRouter;